import { Chip, styled } from '@mui/material';

export const TrlPillQuantityStyled = styled(Chip)(({ theme }) => ({
  borderRadius: '3px',
  border: `solid 1px ${theme.palette.colors.pillBorder}`,
  backgroundColor: theme.palette.colors.pillBackgroundGloomy,
  color: theme.palette.colors.secondaryBackground,
  textTransform: 'uppercase',
  fontWeight: 500,
  height: 'fit-content',
  fontSize: '12px',
  lineHeight: 'normal',
  '& span': {
    padding: '2px 4px',
  },
  width: 92,
  [theme.breakpoints.down('md')]: {
    width: 74,
    fontSize: '10px',
    height: '16px',
  },
}));
